"use client";
// @ts-strict-ignore
import { Link } from "react-scroll";
import styled from "styled-components";

export const DisclaimerLink = styled(Link)`
  :hover {
    cursor: pointer;
    text-decoration: underline;
    text-underline-offset: -0.4em;
  }
`;
